<template>
  <validation-observer
    ref="scoringFormulaSaveFormRef"
    #default="{invalid}"
  >
    <b-modal
      id="scoringFormulaSaveModal"
      body-class="position-static"
      size="lg"
      centered
      no-close-on-backdrop
      :title="isCreated ? 'Thêm công thức tính điểm' : 'Cập nhật công thức tính điểm'"
      @show="onShow"
      @hide="onHide"
    >
      <b-form>
        <b-form-group label-for="name">
          <template v-slot:label>
            Tên công thức tính điểm <span class="text-danger">*</span>
          </template>
          <validation-provider
            #default="{ errors }"
            name="Công thức tính điểm"
            rules="required"
          >
            <b-form-input
              id="name"
              v-model="targetData.name"
              name="name"
              :state="getElementState(errors)"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
        <b-form-group label-for="code">
          <template v-slot:label>
            Mã công thức tính điểm <span class="text-danger">*</span>
          </template>
          <validation-provider
            #default="{ errors }"
            name="Mã công thức tính điểm"
            rules="required"
          >
            <b-form-input
              id="code"
              v-model="targetData.code"
              name="code"
              :state="getElementState(errors)"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
        <b-row>
          <b-col cols="6">
            <b-form-group label-for="status">
              <template v-slot:label>
                Trạng thái <span class="text-danger">*</span>
              </template>
              <validation-provider
                #default="{ errors }"
                name="Trạng thái"
                rules="required"
              >
                <v-select
                  v-model="targetData.status"
                  :options="statusOptions"
                  :reduce="option => option.value"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col cols="6">
            <b-form-group label-for="orderNo">
              <template v-slot:label>
                Thứ tự <span class="text-danger">*</span>
              </template>
              <validation-provider
                #default="{ errors }"
                name="Thứ tự"
                rules="required"
              >
                <b-form-input
                  id="orderNo"
                  v-model="targetData.orderNo"
                  name="orderNo"
                  :state="getElementState(errors)"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>
      </b-form>
      <template #modal-footer>
        <div class="w-100 d-flex justify-content-end">
          <b-button
            v-show="isCreated"
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mr-1"
            :disabled="invalid"
            @click="onSave"
          >
            <span class="text-right">
              <feather-icon icon="CheckIcon" /> Lưu và tiếp tục
            </span>
          </b-button>
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mr-1"
            :disabled="invalid"
            @click="onSave('hide')"
          >
            <span class="text-right">
              <feather-icon icon="CheckIcon" /> Lưu lại
            </span>
          </b-button>

          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="outline-secondary"
            @click="$bvModal.hide('scoringFormulaSaveModal')"
          >
            <span class="text-right">
              <feather-icon icon="XIcon" /> Hủy
            </span>
          </b-button>
        </div>
      </template>
      <b-overlay
        no-wrap
        variant="white"
        spinner-variant="primary"
        blur="0"
        opacity=".75"
        rounded="sm"
        :show="isLoading"
      />
    </b-modal>
  </validation-observer>
</template>

<script>
import {
  BForm, BFormGroup, BModal, BOverlay, BButton, BFormInput, BRow, BCol,
} from 'bootstrap-vue'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { required } from '@validations'
import vSelect from 'vue-select'
import { mapActions, mapGetters } from 'vuex'
import { showErrorToast, showSuccessToast } from '@/utils/notification'
import Ripple from 'vue-ripple-directive'
import { getUser } from '@/auth/utils'
import { STATUSES } from '@/const/status'

export default {
  name: 'ScoringFormulaSave',
  components: {
    BFormGroup,
    BFormInput,
    BModal,
    BForm,
    BOverlay,
    BButton,
    BRow,
    BCol,
    vSelect,
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  props: {
    mainData: {
      type: Object,
      default: undefined,
    },
  },
  data() {
    return {
      user: getUser(),
      isLoading: false,
      targetData: {
        name: '',
        code: '',
        organizationId: null,
        status: 1,
        orderNo: null,
      },
      required,
    }
  },
  computed: {
    ...mapGetters({
      maxOrderNo: 'scoringFormula/maxOrderNo',
    }),
    statusOptions() {
      return STATUSES
    },
    isCreated() {
      return !this.mainData
    },
  },
  methods: {
    ...mapActions({
      createData: 'scoringFormula/createData',
      updateData: 'scoringFormula/updateData',
      getMaxOrderNo: 'scoringFormula/getMaxOrderNo',
    }),
    getElementState(errors) {
      return errors.length > 0 ? false : null
    },
    async onShow() {
      if (this.isCreated) {
        this.targetData.organizationId = this.user.orgId
        this.isLoading = true
        try {
          await this.getMaxOrderNo({ organizationId: getUser().orgId })
          this.targetData.orderNo = this.maxOrderNo + 1
        } catch (e) {
          showErrorToast(this, e)
        } finally {
          this.isLoading = false
        }
      } else {
        this.targetData = { ...this.mainData }
      }
    },
    onHide() {
      this.$refs
        .scoringFormulaSaveFormRef
        .reset()
      this.targetData = {
        name: '',
        code: '',
        organizationId: null,
        status: 1,
        orderNo: null,
      }
    },
    async onSave(type = null) {
      const valid = this.$refs
        .scoringFormulaSaveFormRef
        .validate()
      if (valid) {
        this.isLoading = true
        try {
          const response = this.isCreated
            ? await this.createData(this.targetData)
            : await this.updateData(this.targetData)
          if (response) {
            const { isSuccessful, message } = response
            if (isSuccessful) {
              showSuccessToast(this, message)
              if (type === 'hide') {
                this.$bvModal.hide('scoringFormulaSaveModal')
              }
              this.$emit('succeed')
            } else {
              showErrorToast(this, message)
            }
          }
        } catch (e) {
          showErrorToast(this, e)
        } finally {
          this.isLoading = false
        }
      }
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
